import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { type FC } from "react";

export interface SingleRowBasicProps {
	dueDate: string;
	description: string;
	state?: JSX.Element;
	dateOfPayment?: string;
	insuranceToPay?: string;
	period?: JSX.Element;
	content?: JSX.Element;
}

export interface RowBasicProps {
	row: SingleRowBasicProps;
	titles: string[];
}

const RowBasic: FC<RowBasicProps> = ({ row, titles }) => {
	return (
		<TableRow>
			{titles.map((_, i) => (
				<TableCell key={i}>{Object.values(row)[i]}</TableCell>
			))}
		</TableRow>
	);
}

export default RowBasic;
